import React, { useEffect, useState } from 'react';
import { homeownerPost } from '../utils/homeownerApi';
import { catalogTaskCopy } from '../shared/regionalTaskCopy';
import { showToast } from './Toast';

export default function YearlyCheckinCard({ colors, brandColor = '#59c4c4', client, onAvailability, onSaved }) {
  const [checkin, setCheckin] = useState(null);
  const [items, setItems] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const report = (open) => {
      if (!cancelled && typeof onAvailability === 'function') onAvailability(!!open);
    };
    homeownerPost('/.netlify/functions/homeowner-plan', { action: 'checkin-load' })
      .then((result) => {
        if (cancelled) return;
        const rows = result && result.checkin && result.checkin.items ? result.checkin.items : [];
        if (!result || !result.checkin || !rows.length) {
          report(false);
          return;
        }
        setCheckin(result.checkin);
        setItems(rows.map((item) => ({
          series_id: item.series_id,
          title: item.title,
          answer: item.answer !== false,
        })));
        report(true);
      })
      .catch(() => {
        report(false);
      });
    return () => { cancelled = true; };
  }, [onAvailability]);

  if (!checkin || items.length === 0) return null;

  const save = async (later) => {
    setSaving(true);
    try {
      await homeownerPost('/.netlify/functions/homeowner-plan', {
        action: 'checkin-save',
        checkinId: checkin.id,
        later,
        items,
      });
      setCheckin(null);
      if (typeof onAvailability === 'function') onAvailability(false);
      showToast(later ? 'We will leave these on your list.' : 'Saved. A skipped task is the one you missed.', 'success');
      if (!later && typeof onSaved === 'function') await onSaved();
    } catch (error) {
      showToast('Could not save that check-in.', 'error');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{
      marginBottom: '1.5rem',
      padding: '1rem',
      borderRadius: '0.75rem',
      border: `1px solid ${colors.border}`,
      background: colors.surface,
      paddingBottom: 'calc(1rem + env(safe-area-inset-bottom))',
    }}>
      <h2 style={{ margin: '0 0 0.35rem', color: colors.text, fontSize: '1.2rem' }}>
        Missed tasks
      </h2>
      <p style={{ margin: '0 0 0.75rem', color: colors.textSecondary }}>
        Choose a setting for each missed task. Keep it leaves the rest of the schedule alone. Skip missed clears that overdue task. Next year stays on the list. Nothing changes until you save.
      </p>
      {items.map((item, index) => (
        <div key={item.series_id} style={{ marginBottom: '0.85rem' }}>
          <div style={{ color: colors.text, fontWeight: 650, marginBottom: '0.35rem' }}>
            {(catalogTaskCopy(item.title, client) || {}).title || item.title}
          </div>
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            <button
              type="button"
              aria-pressed={item.answer === true}
              onClick={() => setItems((current) => current.map((row, rowIndex) => (
                rowIndex === index ? Object.assign({}, row, { answer: true }) : row
              )))}
              style={{
                flex: 1,
                minHeight: '44px',
                borderRadius: '0.5rem',
                border: item.answer ? 'none' : `1px solid ${colors.border}`,
                background: item.answer ? brandColor : (colors.surfaceAlt || colors.surface),
                color: item.answer ? '#083838' : colors.text,
                fontWeight: 700,
              }}
            >
              Keep it
            </button>
            <button
              type="button"
              aria-pressed={item.answer === false}
              onClick={() => setItems((current) => current.map((row, rowIndex) => (
                rowIndex === index ? Object.assign({}, row, { answer: false }) : row
              )))}
              style={{
                flex: 1,
                minHeight: '44px',
                borderRadius: '0.5rem',
                border: item.answer ? `1px solid ${colors.border}` : 'none',
                background: item.answer ? (colors.surfaceAlt || colors.surface) : '#991b1b',
                color: item.answer ? colors.text : '#fff',
                fontWeight: 700,
              }}
            >
              Skip missed
            </button>
          </div>
        </div>
      ))}
      <div style={{ display: 'flex', gap: '0.5rem', marginTop: '0.75rem' }}>
        <button type="button" disabled={saving} onClick={() => save(false)} style={{ flex: 1, minHeight: '48px', border: 'none', borderRadius: '0.5rem', background: brandColor, color: '#083838', fontWeight: 700 }}>
          Save
        </button>
        <button type="button" disabled={saving} onClick={() => save(true)} style={{ flex: 1, minHeight: '48px', border: `1px solid ${colors.border}`, borderRadius: '0.5rem', background: 'transparent', color: colors.text }}>
          Later
        </button>
      </div>
    </div>
  );
}
